import { LocalizedText } from '@mews/framework';
import { SearchType, TextKey } from '@mews-commander/enums';
import { ListHeadline } from '@optimus-web/core';

const TITLE_KEYS = {
    [SearchType.Bill]: TextKey.Bill,
    [SearchType.Customer]: TextKey.Customer,
    [SearchType.Company]: TextKey.Company,
    [SearchType.City]: TextKey.City,
    [SearchType.Reservation]: TextKey.Reservation,
    [SearchType.ReservationGroup]: TextKey.Group,
    [SearchType.Resource]: TextKey.Space,
    [SearchType.TravelAgency]: TextKey.TravelAgencyContract,
    [SearchType.ResourceBlock]: TextKey.SpaceBlock,
    [SearchType.Locations]: TextKey.Location,
    [SearchType.Navigation]: TextKey.Navigation,
    [SearchType.EnterpriseProfile]: TextKey.Employee,
    [SearchType.ProductServiceOrder]: TextKey.ProductOrder,
};

interface Props {
    type: SearchType;
}

const ResultSectionTitle = (props: Props) => (
    <ListHeadline>
        <LocalizedText textKey={TITLE_KEYS[props.type]} />
    </ListHeadline>
);

export default ResultSectionTitle;
